import { createApp } from 'vue';
import VueScrollTo from 'vue-scrollto';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import './assets/css/styles.css';

createApp(App).use(router, VueScrollTo).directive('scroll-to', VueScrollTo).mount('#app');
